import { HazmatInformationStatus, Product } from "@deliverr/commons-clients";
import { UnId } from "common/clients/core/UnId";
import { ProductListItem } from "inventory/list/InventoryListReducer";

export const getApprovedHazmatInfo = (product: Product | ProductListItem | undefined): UnId[] => {
  const hazmatInfo = product?.hazmatInformation;
  return hazmatInfo?.status === HazmatInformationStatus.APPROVED ? hazmatInfo.hazmatIds : [];
};
